import Vue from 'vue'
import VueRouter from 'vue-router'
import { isClient } from '@/utils'

Vue.use(VueRouter)

export default function createRouter(context) {
  const routes = [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue'),
      meta: {
        ssr: true,
        withoutLayout: true,
        hide_sidebar: true,
      },
    },
    {
      path: '/aboutus',
      name: 'Aboutus',
      component: () => import('@/views/Aboutus.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands',
      name: 'Brand',
      component: () => import('@/views/Brand.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/heweifang',
      name: 'HeWeiFang',
      component: () => import('@/views/BrandInfo/HeWeiFang.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/dazuie',
      name: 'DaZui',
      component: () => import('@/views/BrandInfo/DaZuiE.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/luxiaobai',
      name: 'LuXiaoBai',
      component: () => import('@/views/BrandInfo/LuXiaoBai.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/kelike',
      name: 'KeLiKe',
      component: () => import('@/views/BrandInfo/KeLiKe.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/baimi',
      name: 'BaiMi',
      component: () => import('@/views/BrandInfo/BaiMi.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/niandutang',
      name: 'NianDuTang',
      component: () => import('@/views/BrandInfo/NianDuTang.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/ourbrands/diaryluck',
      name: 'DiaryLuck',
      component: () => import('@/views/BrandInfo/DiaryLuck.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/influencer',
      name: 'Influencer',
      component: () => import('@/views/Influencer.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/seller',
      name: 'Seller',
      component: () => import('@/views/Seller.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/partner',
      name: 'Partner',
      component: () => import('@/views/partner.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/apply-join',
      name: 'ApplyJoin',
      component: () => import('@/views/ApplyJoin.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/join-us',
      name: 'JoinUs',
      component: () => import('@/views/JoinUs.vue'),
      meta: {
        ssr: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login.vue'),
      meta: {
        ssr: true,
        title: '登录',
        withoutLayout: true,
      },
    },
    {
      path: '/404',
      name: '404',
      redirect: '/',
    },

    { path: '*', name: 'CmsDynamic', component: () => import('@/cms/CmsDynamicPage.vue'), meta: { ssr: true } },
]

  // 阻止服务端渲染刷新报错
  // const originalPush = VueRouter.prototype.push
  // VueRouter.prototype.push = function push(location, onResolve, onReject) {
  //   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  //   return originalPush.call(this, location).catch(err => err)
  // }

  // const originalReplace = VueRouter.prototype.replace
  // VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  //   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  //   return originalReplace.call(this, location).catch(err => err)
  // }

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
  })

  router.beforeEach((to, from, next) => {
    isClient(() => {
      if (to.meta.title) {
        document.title = to.meta.title
      }
      // document.title = to.meta.title || '魔筷科技'
    })

    // 如果当前页面在新系统中不存在且当前页面不存在，本地会死循环，对应的处理
    if (!from.name && !to.name) {
      next('404')
      return false
    }

    // 如果跳转的路由，新系统里没有，则location跳转
    if (to.name) {
      next()
    } else {
      console.log(context.type)
      context.type === 'server'
        ? router.$$redirect(to.path)
        : (location.href = to.path)
    }
  })

  return router
}
